<template>
  <v-app-bar app color="primary" dark fixed clipped-left elevation="5">
    <v-app-bar-nav-icon
      @click="setDrawer(!drawer)"
      v-if="usuarioLogado"
    ></v-app-bar-nav-icon>
    <a @click="$router.push({ path: '/' })">
      <v-img
        class="mx-2"
        src="../assets/logo.png"
        max-height="35"
        max-width="35"
        contain
      ></v-img
    ></a>
    <v-toolbar-title>Coasul - Nutrição Animal</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-chip color="warning" small v-if="isModeDevelopment()" class="mr-3"
      >Servidor Desenvolvimento</v-chip
    >
    <span class="body-2" v-if="usuarioLogado && !isMobile()">{{
      usuarioLogado.usuario
    }}</span>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
export default {
  name: "HeaderTemplate",
  computed: {
    ...mapState("sistema", ["drawer"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  methods: {
    ...mapMutations("sistema", ["setDrawer"]),
    ...mapGetters("sistema", ["isModeDevelopment"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.setDrawer(!this.isMobile());
  },
};
</script>

<style>
</style>